<template>
  <v-dialog persistent v-if="editableCompany" v-model="showModal" max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">
          {{ checkCompany(editableCompany.blitzInvitation, 'company') || checkCompany(editableCompany.metadata, 'companyName') }}
          Blitz Registration
        </span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <h3 class="text-xs-center py-2 my-2">Blitz Invitation</h3>
              <v-flex xs12>
                <v-layout row class="mb-1">
                  <v-flex xs6 class="border text-xs-center py-2">
                      <span class="body-2">Name: </span>{{ checkCompany(editableCompany.metadata, 'name') }}
                  </v-flex>
                  <v-flex xs6 class="border text-xs-center py-2">
                    <span class="body-2">Status: </span>{{ checkCompany(editableCompany.metadata, 'category') }}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row class="mb-1">
                  <v-flex xs6 class="border text-xs-center py-2">
                    <span class="body-2">Company: </span>{{ checkCompany(editableCompany.metadata, 'companyName') }}
                  </v-flex>
                  <v-flex xs6 class="border text-xs-center py-2">
                    <span class="body-2">Email: </span>{{ checkCompany(editableCompany.metadata, 'email') }}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 class="px-2 border text-xs-center py-2">
                <span class="body-2">Description: </span>{{ checkCompany(editableCompany.metadata, 'companyDescription') }}
              </v-flex>
            </v-flex>
            <v-flex xs12>
              <h3 class="text-xs-center py-2 my-2">Blitz Card</h3>
              <v-layout row justify-space-around>
                <v-flex xs5 class="border text-xs-center py-2">
                  <span class="body-2">CompanyName: </span>{{ checkCompany(editableCompany.metadata, 'companyName') }}
                </v-flex>
                <v-flex xs4 class="border text-xs-center py-2">
                  <span class="body-2">Status: </span>{{ checkCompany(editableCompany.metadata, 'status') }}
                </v-flex>
                <v-flex xs3 class="border text-xs-center py-2">
                  <span class="body-2">Order: </span>{{ checkCompany(editableCompany.metadata, 'order') }}
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <h3 class="text-xs-center py-2 my-2">Blitz Invitation</h3>
              <v-flex xs12>
                <v-layout row>
                  <v-flex xs6 class="border text-xs-center py-2">
                    <span class="body-2">Name: </span>{{ checkCompany(editableCompany.blitzInvitation, 'name') }}
                  </v-flex>
                  <v-flex xs6 class="border text-xs-center py-2">
                    <span class="body-2">Status: </span>{{ checkCompany(editableCompany.blitzInvitation, 'status') }}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row class="my-1">
                  <v-flex xs6 class="border text-xs-center py-2">
                    <span class="body-2">Company: </span>{{ checkCompany(editableCompany.blitzInvitation, 'company') }}
                  </v-flex>
                  <v-flex xs6 class="border text-xs-center py-2">
                    <span class="body-2">Email: </span>{{ checkCompany(editableCompany.blitzInvitation, 'email') }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-flex>
            <v-flex xs12>
              <h3 class="text-xs-center py-2 my-2">Participants</h3>
              <div v-for="(val, index) in editableCompany.metadata.participants" :key="index">
                <v-layout row justify-space-around class="my-2">
                  <v-flex xs4 class="border text-xs-center py-2"><span class="body-2">Name: </span>{{val.name}}</v-flex>
                  <v-flex xs5 class="border text-xs-center py-2"><span class="body-2">Email: </span>{{val.email}}</v-flex>
                  <v-flex xs3 class="border text-xs-center py-2"><span class="body-2">Order: </span>{{val.order}}</v-flex>
                </v-layout>
              </div>

            </v-flex>
            <v-flex xs12 class="text-xs-center py-2">
              <v-btn
                color="blue darken-1"
                flat="flat"
                @click="closeModal()"
              >
                close
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { pathOr } from 'ramda'

  export default {
    name: 'ModalCompanyInfo',
    props: {
      show: {
        default: false,
        required: true,
        type: Boolean
      },
      editableCompany: {
        required: true,
        type: Object
      }
    },
    data () {
      return {
        showModal: false
      }
    },
    watch: {
      show: {
        handler () {
          this.showModal = this.show
        },
        immediate: true,
      },
      showModal (val) {
        if (!val) this.closeModal()
      }
    },
    methods: {
      closeModal () {
        this.$emit('close')
      },
      checkCompany (editableCompany, value) {
        return pathOr('', value, editableCompany)
      }
    }
  }
</script>

<style>
  .border {
    border: 1px solid #adadad;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/BlitzList/modalCompanyInfo.vue